const Head = (props) => {
	let language = props.language || {}

	return (
		<thead>
			<tr>
				<th className='checklist-th'>
					{/* {language.manager_report ? language.manager_report.section : null}{' '}
					{props.index + 1} */}
					{props?.name}
				</th>
				<th className='checklist-th center-aligned'>
					{props.rating === 'yes-no'
						? language.general
							? language.general.yes
							: null
						: 1}
				</th>
				<th className='checklist-th center-aligned'>
					{props.rating === 'yes-no'
						? language.general
							? language.general.no
							: null
						: 2}
				</th>
				{props.rating !== 'yes-no' ? (
					<th className='checklist-th center-aligned'>3</th>
				) : null}
				<th className='checklist-th'>
					{language.general ? language.general.comments : null}
				</th>
			</tr>
		</thead>
	)
}

export default Head
